import "../styles/home.scss";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import Diff from "./Diff";
import Paul from "../images/paul_cropped.webp";
import Richard from "../images/richard_cropped.webp";
import { useNavigate } from "react-router-dom";
import event from "../images/event.webp";
import telegram from "../images/support_group.webp";
import online from "../images/ZoomCall.webp";
import retreat from "../images/retreat.webp";

export default function Retreat() {
  const navigate = useNavigate();
  return (
    <main className="home__main">
      <section className="hero">
        <h1>The Elite Retreat 2025</h1>
        <p>
          14th-18th July. North Wales
          <br />A private, all-inclusive client only experience — hosted by Paul
          & Richard
        </p>
      </section>
      <section
        className="skills"
        style={{ backgroundColor: "rgb(234, 175, 89, 0.15)" }}
      >
        <h2>
          You’re already operating at a level most people never reach. But when
          the pace has been high for a while, momentum starts to stall.
        </h2>
        <h3>
          You know there’s more. Not just in revenue... but in who you are when
          you lead. What you stand for. And how you want to grow next.
        </h3>
        <h3>
          Elite Retreat 2025 is built for that exact moment. Not another
          “course”. A deep, immersive reset with people who get it.
        </h3>
      </section>
      <section className="extras" style={{ backgroundColor: "#fff" }}>
        <h2>What It’s About</h2>
        <hr />
        <section className="extra__boxes">
          <aside
            className="text__side"
            style={{ backgroundColor: "rgb(234, 175, 89, 0.15)" }}
          >
            <h4>This retreat is about scale</h4>
            <p>But not just in your notebooks </p>
          </aside>
          <img src={event} alt="In Person Event" />
        </section>
        <section className="extra__boxes">
          <aside
            className="text__side"
            style={{ backgroundColor: "rgb(234, 175, 89, 0.15)" }}
          >
            <h4>It’s about identity</h4>
            <p>Energy. Vision. Opportunity. </p>
          </aside>
          <img src={online} alt="Online Sessions" />
        </section>
        <section className="extra__boxes">
          <aside
            className="text__side"
            style={{ backgroundColor: "rgb(234, 175, 89, 0.15)" }}
          >
            <h4>The truth is</h4>
            <p>
              adding new revenue streams or evolving your model only works when
              your thinking evolves first.
            </p>
          </aside>
          <img src={telegram} alt="Private telegram group" />
        </section>
        <section className="extra__boxes">
          <aside
            className="text__side"
            style={{ backgroundColor: "rgb(234, 175, 89, 0.15)" }}
          >
            <h4>
              And that doesn’t happen in a hotel event room with 100+ other
              people.
            </h4>
            <p>
              These breakthroughs happen via intimate learning, dismantling your
              barriers and opening your eyes to new opportunity.
            </p>
          </aside>
          <img src={retreat} alt="PMW Retreat" />
        </section>
      </section>
      <Diff />
      <section className="skills">
        <h2>This is your opportunity to truly reinvent who you are. </h2>
      </section>
      <section className="house">
        <h2>The Home</h2>
        <h3>
          A brand-new, private home in rural North Wales, designed for presence,
          focus and expansion.
        </h3>
        <section className="house__ticks">
          <section className="ticks--row">
            <TaskAltIcon className="online--icon" />
            <p>Private bedrooms with luxury finishes</p>
          </section>
          <section className="ticks--row">
            <TaskAltIcon className="online--icon" />
            <p>Spa, sauna, hot tub, games room, and speaking spaces</p>
          </section>
          <section className="ticks--row">
            <TaskAltIcon className="online--icon" />
            <p>Gourmet food, incredible hosting, and room to breathe</p>
          </section>
          <section className="ticks--row">
            <TaskAltIcon className="online--icon" />
            <p>Private chefs catering breakfast, lunch and dinner every day</p>
          </section>
          <section className="ticks--row">
            <TaskAltIcon className="online--icon" />
            <p>No distractions. Just space to think bigger</p>
          </section>
        </section>
        <h3>This is where powerful decisions get made</h3>
      </section>
      <section className="house" style={{ backgroundColor: "#fff" }}>
        <h2>Why Now</h2>
        <section className="house__ticks">
          <section className="ticks--row">
            <TaskAltIcon className="online--icon" />
            <p>
              This retreat runs once a year, and only for our private client
              base. No livestreams, no half-in, half-out energy
            </p>
          </section>
          <section className="ticks--row">
            <TaskAltIcon className="online--icon" />
            <p>
              This is a reset for the second half of the year. A container for
              big ideas, powerful conversations, and decisions that change your
              future
            </p>
          </section>
          <section className="ticks--row">
            <TaskAltIcon className="online--icon" />
            <p>
              There’s no better place to build your next step. And no better
              time to start it
            </p>
          </section>
        </section>
        <h3>This is where powerful decisions get made.</h3>
      </section>
      <section className="hosted">
        <h2>Hosted by</h2>
        <section className="bios">
          <article>
            <img src={Paul} alt="Paul McFadden" />
            <aside className="bios--text">
              <h4>Paul McFadden</h4>
              <p>Multi 8-Figure Educator & Property Investor </p>
            </aside>
          </article>
          <article>
            <img src={Richard} alt="Richard Dickson" />
            <aside className="bios--text">
              <h4>Richard Dickson</h4>
              <p>Strategic Growth Advisor & Founder of Growth Getters</p>
            </aside>
          </article>
        </section>
        <h5>
          Plus: Secret 8 and 9-figure guests — invited exclusively for this
          experience.
        </h5>
      </section>
      <section className="house" style={{ backgroundColor: "#fff" }}>
        <h2>You'll Leave With</h2>
        <section className="house__ticks">
          <section className="ticks--row">
            <TaskAltIcon className="online--icon" />
            <p>Clarity on what’s next, and how to execute</p>
          </section>
          <section className="ticks--row">
            <TaskAltIcon className="online--icon" />
            <p>A real plan to add new income </p>
          </section>
          <section className="ticks--row">
            <TaskAltIcon className="online--icon" />
            <p>Access to thinking you wouldn’t get anywhere else </p>
          </section>
          <section className="ticks--row">
            <TaskAltIcon className="online--icon" />
            <p>Deeper personal confidence and energy</p>
          </section>
          <section className="ticks--row">
            <TaskAltIcon className="online--icon" />
            <p>And a renewed sense of what you’re really capable of</p>
          </section>
          <section className="ticks--row">
            <TaskAltIcon className="online--icon" />
            <p>
              A bespoke content bundle including short form videos and personal
              images
            </p>
          </section>
          <section className="ticks--row">
            <TaskAltIcon className="online--icon" />
            <p>
              Ready to apply strategies from your{" "}
              <strong>personal 1-2-1 sessions</strong> with Paul and Richard{" "}
            </p>
          </section>
        </section>
      </section>
      <section className="retreat__apply">
        <h2>Apply To Join Us</h2>
        <p>
          Dates: <strong>14–18 July 2025</strong>
        </p>
        <p>
          Location: <strong>Private estate, North Wales</strong>
        </p>
        <p>
          Investment: <strong>£4,995 + VAT</strong> (all inclusive)
        </p>
        <h5>
          This is an application only experience for our clients. Spots are
          extremely limited. Once they’re gone, they’re gone.{" "}
        </h5>
        <button onClick={() => navigate("/retreat-interest")}>Apply Now</button>
        <h6 className="counter">60% Full</h6>
      </section>
    </main>
  );
}
